class CartAddOnsLoader extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.loadRecommendations();
    this.bindCartUpdates();
  }

  bindCartUpdates() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.refreshSection();
    });
  }

  disconnectedCallback() {
    this.cartUpdateUnsubscriber?.();
  }

  refreshSection() {
    const hostSection = this.closest('.shopify-section');
    if (!hostSection?.id) return;

    const sectionId = hostSection.id.replace('shopify-section-', '');

    fetch(`${window.location.pathname}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const updated = doc.getElementById(hostSection.id);
        if (updated) hostSection.replaceWith(updated);
      })
      .catch(() => {});
  }

  loadRecommendations() {
    const list = document.querySelector(this.dataset.listSelector);
    if (!list) return;

    const productIds = (this.dataset.productIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    if (!productIds.length) {
      this.hideSectionIfEmpty(list);
      return;
    }

    const maxItems = parseInt(this.dataset.maxItems || '6', 10);
    const sectionId = this.dataset.sectionId;
    const baseUrl = this.dataset.url;
    const seenIds = new Set();

    list.querySelectorAll('[data-product-id]').forEach((node) => {
      seenIds.add(node.dataset.productId);
    });

    const loadingEl = this.querySelector('.cart-add-ons__loading');
    if (loadingEl) loadingEl.hidden = false;

    Promise.all(
      productIds.map((productId) =>
        fetch(`${baseUrl}&product_id=${productId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('[data-addon-card]'));
          })
          .catch(() => [])
      )
    )
      .then((groups) => {
        groups.flat().forEach((card) => {
          const productId = card.dataset.productId;
          if (!productId || seenIds.has(productId)) return;
          if (list.querySelectorAll('[data-addon-card]').length >= maxItems) return;

          seenIds.add(productId);
          list.appendChild(card);
        });
      })
      .finally(() => {
        if (loadingEl) loadingEl.hidden = true;
        this.hideSectionIfEmpty(list);
      });
  }

  hideSectionIfEmpty(list) {
    const section = this.closest('.cart-add-ons');
    if (!section) return;

    if (!list.querySelector('[data-addon-card]')) {
      section.hidden = true;
    }
  }
}

customElements.define('cart-add-ons-loader', CartAddOnsLoader);
